import { Injectable } from '@angular/core';
import { PopoverController, PopoverOptions, Popover } from 'ionic-angular';
import { PopupTrackingObject } from './base';

/**
 * Provides a simple modal mechanism that does not depend on the settingsProvider/apiProvider
 * There is no doNotShow functionality here (which requires user authentication)
 */
@Injectable()
export class PopoverProvider {
    private popovers: PopupTrackingObject[] = [];
    private closingPopovers = false;

    constructor(private popoverCtrl: PopoverController) {
        window.addEventListener('resize', () => {
            this.popovers.forEach(popover => {
                popover.component.dismiss();
            });
        });
    }

    public createPopover(component: any, data?: {}, opts?: PopoverOptions): Popover {
        const popover = this.popoverCtrl.create(component, data, opts);

        // In order to bake in on-dismiss logic without clobbering the 'onDidDismiss' handler,
        // we hook onWillDismiss (which fires just before the dismissal animation).
        popover.onWillDismiss(() => {
            const popoverIndexToRemove = this.popovers.findIndex(popover => {
                return component === popover.componentName;
            });
            if (popoverIndexToRemove >= 0) {
                this.popovers.splice(popoverIndexToRemove, 1);
            }
        });

        const popoverAlreadyExists = this.popovers.find(popover => {
            return component === popover.componentName;
        });

        if (popoverAlreadyExists) {
            // Short-circuit the popover and prevent it from showing.
            popover.present = async () => {};
            return popover;
        }

        // If we haven't already created this popover, start tracking it.
        this.popovers.push({ componentName: component, component: popover });
        return popover;
    }

    public async closeAll(): Promise<void> {
        if (!this.closingPopovers) {
            this.closingPopovers = true;

            try {
                await Promise.all(
                    this.popovers.map(async (popover: PopupTrackingObject) => popover.component.dismiss())
                );
            } catch (err) {
                throw err;
            } finally {
                this.popovers = [];
                this.closingPopovers = false;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/providers/popup/popover.ts